var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('datepicker',{ref:"datepicker",attrs:{"language":_vm.ptBR,"format":"dd/MM/yyyy","disabled-dates":_vm.disabledDates},on:{"input":_vm.onChange}})}
var staticRenderFns = []

export { render, staticRenderFns }